import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { useServices } from '../../services';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailVerificationWarning',
  props: {
    email: null
  },
  setup(__props: any) {

const props = __props as {
  email: string;
};



const resentCode = ref(false);

const requestManager = useRequestManager({
  exposeToParent: false,
}).manager;

const services = useServices();

const router = useRouter();

function resendVerificationCode() {
  if (resentCode.value) {
    return;
  }
  requestManager
    .currentOrNew('resendVerification', services.registration.resendRegistrationConfirmation(props.email))
    .subscribe(
      () => {
        resentCode.value = true;
      },
      () => {
        router.push('/login');
      }
    );
}

return { __sfc: true,props, resentCode, requestManager, services, router, resendVerificationCode }
}

})